"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedDate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const FormattedDate = props => {
    if (props.value) {
        return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedDate, { ...props });
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "- - -" });
};
exports.FormattedDate = FormattedDate;
